var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIndicator1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "489px",
    height: "76px",
    viewBox: "0 0 489 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u270F\\uFE0F-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Donation-plan--Copy",
    transform: "translate(-603.000000, -194.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(603.000000, 194.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Forever",
    transform: "translate(415.700000, 3.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    points: "39.6913744 65.971831 43.8009421 65.2935276 43.9864215 66.4243148 41.1773126 66.888195 41.4212538 68.3760729 43.5019038 68.0324892 43.6873832 69.1636985 41.6067332 69.5072822 42.0210126 72.0389962 40.7209744 72.2538415"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(0.000000, 0.125362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.8699556,66.7970229 C48.483435,65.7088671 47.9093321,64.8836752 46.9407174,65.2306357 C45.9721026,65.5775962 46.0494909,66.5804892 46.4368526,67.6690671 C46.8237938,68.757645 47.3970556,69.5824148 48.3656703,69.2350322 C49.334285,68.8880717 49.2577379,67.8851787 48.8699556,66.7970229 M45.1119997,68.1434997 C44.4769115,66.3576241 44.7620703,64.7473392 46.5419997,64.1095566 C48.3215085,63.4717741 49.5588791,64.5362927 50.1943879,66.3221683 C50.8298968,68.1080438 50.5447379,69.7187508 48.7648085,70.3565334 C46.9848791,70.9943159 45.7470879,69.9297973 45.1119997,68.1434997",
    id: "Fill-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3149003,64.0876078 C53.818765,63.7824345 53.9129768,63.3240415 53.6677738,62.9167217 C53.4234121,62.5089799 52.975065,62.378131 52.4712003,62.6833043 L51.5459062,63.2434217 L52.3900268,64.6477252 L53.3149003,64.0876078 Z M49.8282238,62.945002 L51.8815356,61.7023601 C53.0621268,60.9873345 54.1914062,61.0557136 54.8714974,62.1881892 C55.4657885,63.1771531 55.1650679,64.2133915 54.3154797,64.7279229 L54.3079091,64.7321438 L57.3458179,65.8274752 L55.9010974,66.7016299 L52.9565591,65.5915252 L54.2313621,67.7125427 L53.1033444,68.3950671 L49.8282238,62.945002 Z",
    id: "Fill-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    fill: "#FFFFFF",
    points: "54.5372138 59.9553171 57.655455 57.1817438 58.413355 58.040281 56.2813932 59.9359008 57.1911256 60.9662299 58.7700138 59.5615043 59.5279138 60.4200415 57.9490256 61.824345 58.9761021 62.9863671 61.1728344 61.0320764 61.931155 61.8901915 58.7468815 64.7220136"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#FFFFFF",
    points: "57.9569747 56.9763534 58.8120306 55.8679371 63.4851865 57.460072 60.7286512 53.3868743 61.5837071 52.278458 65.2369365 57.941258 64.3322512 59.1125662"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#FFFFFF",
    points: "61.7069394 51.9252506 63.6084188 48.206611 64.62456 48.7304285 63.3249424 51.2718506 64.5442276 51.899925 65.5073747 50.016968 66.5235159 50.5407855 65.5603688 52.4237424 66.9361129 53.1320145 68.2761071 50.511661 69.2926688 51.0354785 67.3508129 54.8326273"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3294471,45.7764527 C67.496,45.2095817 67.2571059,44.8081713 66.8016088,44.6731015 C66.3469529,44.5380317 65.9288882,44.7457015 65.7614941,45.3121503 L65.4561471,46.3521876 L67.0232588,46.816912 L67.3294471,45.7764527 Z M63.9870324,47.2964097 L64.6662824,44.9875608 C65.0574294,43.6596562 65.9356176,42.9454748 67.1994853,43.3198713 C68.3035294,43.6469934 68.7792147,44.6152748 68.4982618,45.5713155 L68.4957382,45.5793352 L71.4747647,44.3286736 L70.9973971,45.9528876 L68.0768324,47.1288387 L70.4447441,47.8303573 L70.0716824,49.0987469 L63.9870324,47.2964097 Z",
    id: "Fill-12",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.4089544,71.4033663 C14.8318338,70.6178512 -0.403554412,54.0536547 0.380001471,34.4064907 C1.16313676,14.7597488 17.6678603,-0.530148837 37.2449809,0.255788372 C56.8216809,1.04214767 72.0570691,17.6059221 71.2735132,37.253086",
    id: "Stroke-14",
    stroke: "#FFFFFF",
    strokeWidth: 2.36964201,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1917809,14.9271931 C38.0247515,13.3852873 34.1444044,14.0251803 31.6444279,16.4758524 C29.7597721,18.3225094 28.9997691,20.5997013 29.0489779,23.2297629 C28.7915779,23.3019408 28.5674044,23.3758071 28.3386044,23.4260362 C23.4244515,24.477892 19.9196897,29.292285 20.4853809,34.2189548 C21.0985985,39.5715164 25.6388485,43.5417234 30.8894721,43.3416513 C31.5876485,43.3146373 31.9930956,43.0255036 32.0090779,42.3303164 C32.0250603,41.6195117 31.5666191,41.3096955 30.913025,41.2649536 C30.4020103,41.230342 29.8817426,41.2750838 29.3761956,41.2067048 C25.7725956,40.7141222 22.7102926,37.4935524 22.5361691,34.0357664 C22.3208279,29.7895106 24.6571956,26.4406245 28.5501603,25.4959803 C29.4485368,25.2777583 30.3893926,25.2321722 31.456425,25.0886606 C31.3853456,24.7315699 31.3382397,24.441592 31.2709456,24.1566792 C30.0714279,19.0274048 34.8661338,14.9006013 39.5140544,16.4408187 C42.0594544,17.2837385 44.2006691,19.8639931 43.8726103,23.2057036 C43.7914368,24.0182327 44.2179132,24.5829931 44.8496368,24.5576676 C45.5457103,24.5285431 45.8262426,24.0612862 45.8973221,23.4167501 C46.2779544,19.9146443 44.3739515,16.4754303 41.1917809,14.9271931",
    id: "Fill-16",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9793976,41.0472802 C41.61443,41.0924442 39.4706918,41.7260058 37.5797271,43.5545128 C37.5797271,39.14955 37.5805682,34.9446593 37.5784653,30.7410349 C37.5784653,29.7959686 37.1738594,29.2151686 36.5051241,29.2729953 C35.6681535,29.3451733 35.4637476,29.9061349 35.4650094,30.6785651 C35.4788888,38.9743814 35.47258,47.2685093 35.4751035,55.5639035 C35.4751035,56.4621174 35.8708771,56.9897337 36.5375094,56.9331733 C37.3791065,56.8635279 37.5919241,56.2941244 37.5868771,55.5292919 C37.5683712,53.3799942 37.5671094,51.2298523 37.5830918,49.0805547 C37.6028594,46.6598512 38.6820888,44.8777744 40.9406476,43.9833593 C41.9311329,43.5903907 43.0238212,43.4409698 44.0837035,43.2527163 C44.7987035,43.1260884 45.4270624,42.9585174 45.3850035,42.076343 C45.3408418,41.2005 44.7213153,41.0337733 43.9793976,41.0472802",
    id: "Fill-18",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Start"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Clip-2",
    points: "0 0 58.3 0 58.3 75.9 0 75.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1903686,46.2577456 L5.20216681,46.2458187 C1.9306924,41.482714 0,35.7066723 0,29.468036 C0,13.1928883 13.050503,0 29.15,0 C45.249497,0 58.3,13.1928883 58.3,29.468036 C58.3,35.7066723 56.3709931,41.482714 53.0986759,46.2458187 L53.1113169,46.2577456 L52.6714123,46.8251267 C52.227294,47.4385117 51.7713776,48.0382658 51.2842801,48.6124623 L30.7318025,75.1217678 C29.927839,76.1594107 28.3730038,76.1594107 27.5681975,75.1217678 L7.01571986,48.6124623 C6.52946516,48.0382658 6.07354871,47.4385117 5.6302732,46.8259786 L5.1903686,46.2577456 Z",
    id: "Fill-1",
    fill: "#DC093D"
  })), /*#__PURE__*/React.createElement("text", {
    id: "START",
    fontFamily: "Montserrat-Medium, Montserrat",
    fontSize: 13.2,
    fontWeight: 400,
    letterSpacing: 1.1,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5.5,
    y: 35
  }, "STAR"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.5104,
    y: 35
  }, "T"))), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    fill: "#FFA300",
    fillRule: "nonzero",
    cx: 87,
    cy: 37,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy",
    fill: "#FFA300",
    fillRule: "nonzero",
    cx: 117,
    cy: 37,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy-2",
    fill: "#FFA300",
    fillRule: "nonzero",
    cx: 147,
    cy: 37,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy-3",
    fill: "#FFA300",
    fillRule: "nonzero",
    cx: 177,
    cy: 37,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy-7",
    stroke: "#FFA300",
    fillRule: "nonzero",
    cx: 293,
    cy: 37,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy-6",
    stroke: "#FFA300",
    fillRule: "nonzero",
    cx: 323,
    cy: 37,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy-5",
    stroke: "#FFA300",
    fillRule: "nonzero",
    cx: 353,
    cy: 37,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2-Copy-4",
    stroke: "#FFA300",
    fillRule: "nonzero",
    cx: 383,
    cy: 37,
    r: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(212.000000, 4.000000)",
    stroke: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.26599994
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4341961,13.7031333 C35.2221373,13.7031333 38.2930196,10.6585879 38.2930196,6.90313333 C38.2930196,3.14767879 35.2221373,0.103133333 31.4341961,0.103133333 C27.6462549,0.103133333 24.5753725,3.14767879 24.5753725,6.90313333 C24.5753725,10.6585879 27.6462549,13.7031333 31.4341961,13.7031333 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2479216,43.3757576 L12.1972745,50.8928485 L3.82431373,61.0052727 C3.04386275,61.9428485 2.82666667,63.2204242 3.25378431,64.3589091 C3.68194118,65.4973939 4.68998039,66.3226667 5.89754902,66.5256364 C7.10615686,66.7265455 8.33139216,66.2752727 9.11184314,65.337697 L19.4832157,53.6787879 L20.5224314,47.4969697",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3399314,37.1939394 C28.3399314,37.1939394 31.175951,29.1081212 31.8233824,27.2628485 C32.3398725,28.1612727 36.0623431,34.635697 36.0623431,34.635697 C36.7804412,35.8844242 38.2145588,36.55 39.6424412,36.2986061 L49.7373824,34.5151515 C51.3751863,34.2266667 52.4663627,32.6760606 52.1753824,31.0533333 C51.9020686,29.5511515 50.5313431,28.4950909 48.9953824,28.6032727 L40.8271471,29.1874545 C40.8271471,29.1874545 35.7942255,20.2258788 35.6237941,20.0064242 C34.553402,18.6247879 30.2022059,18.2054545 28.5508922,17.7624242 C26.8434608,17.3029091 25.1349902,16.8444242 23.4265196,16.3859394 C23.0233039,16.2767273 22.6024216,16.2427273 22.1877745,16.2839394 L5.62683333,17.9406667 C4.18336275,18.0859394 2.98826471,19.1141818 2.64116667,20.5112727 L0.191735294,30.3836364 C-0.205245098,31.983697 0.780970588,33.6012727 2.39591176,33.9958788 C3.89134314,34.3585455 5.42210784,33.5435758 5.94379412,32.1073333 L8.7185,24.4676364 L19.448402,23.3950909 L15.2499706,33.4374545 C14.5027745,35.4589091 14.7636176,37.7121818 15.955598,39.5121212 C17.1465392,41.3120606 19.1272843,42.4464242 21.2961275,42.5700606 L30.9151078,48.5272727 C30.9587549,50.6651515 31.002402,52.802 31.046049,54.9409091 C31.0772255,56.4935758 31.1094412,58.048303 31.1406176,59.602 C31.1905,62.0314545 30.3082059,65.3747879 33.0475784,66.6956364 C35.2652647,67.7640606 37.3634412,66.1763636 37.8310882,64.0209697 C38.0617941,62.9566667 37.9952843,61.8542424 37.9495588,60.7652121 C37.8404412,58.1348485 37.8549902,55.5003636 37.9973627,52.8720606 C38.1771471,49.5307879 39.5696961,46.0009697 36.4250294,43.5849091 C35.0397549,42.5206061 33.4871667,41.6912121 32.0811078,40.6351515 C29.8374412,38.9475152 27.7299118,37.0867879 25.7491667,35.1034545",
    id: "Stroke-5"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndicator1);
export default __webpack_public_path__ + "static/media/indicator-1.27e2ac970c52344821305d3434188100.svg";
export { ForwardRef as ReactComponent };